import { useState } from "react";
import { CalendarIcon, Pencil } from "lucide-react";
import { fr } from "date-fns/locale";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { OpeningDaysList } from "./opening-days-list";
import { AgeGroupsSection } from "./age-groups-section";
import {
  mockOpeningDates,
  mockOpeningDays,
  mockClosures,
} from "../mock-data";

export function ClubDetailsSection() {
  const [openingDates] = useState(mockOpeningDates);
  const [openingDays] = useState(mockOpeningDays);
  const [closureDates] = useState<Date[]>(
    mockClosures.map((d) => new Date(d))
  );
  const [selectedMonth, setSelectedMonth] = useState<Date>(new Date(2025, 1, 1)); // February 2025

  const handleDayClick = (dayId: string) => {
    // TODO: Open sheet to edit day schedule
    console.log("Edit schedule for:", dayId);
  };

  return (
    <div className="rounded-xl border bg-white p-6">
      <div className="space-y-6">
        {/* Opening dates */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <h3 className="mb-2 text-sm font-semibold text-gray-700">Date d'ouverture</h3>
            <div className="flex items-center gap-2 rounded-lg border bg-gray-50 px-3 py-2">
              <CalendarIcon className="h-4 w-4 text-gray-400" />
              <span className="text-sm text-gray-900">{openingDates.startDate}</span>
            </div>
          </div>
          <div>
            <h3 className="mb-2 text-sm font-semibold text-gray-700">Date de fermeture</h3>
            <div className="flex items-center gap-2 rounded-lg border bg-gray-50 px-3 py-2">
              <CalendarIcon className="h-4 w-4 text-gray-400" />
              <span className="text-sm text-gray-900">{openingDates.endDate}</span>
            </div>
          </div>
        </div>

        {/* Main grid: Days / Calendar / Age Groups */}
        <div className="flex gap-6">
          {/* Opening days list - narrow fixed width */}
          <div className="w-40 flex-shrink-0">
            <OpeningDaysList
              openingDays={openingDays}
              onDayClick={handleDayClick}
            />
          </div>

          {/* Exceptional closures calendar */}
          <div className="flex-shrink-0">
            <h3 className="mb-3 text-sm font-semibold text-gray-700">
              Fermetures exceptionnelles
            </h3>
            <Calendar
              mode="multiple"
              selected={closureDates}
              onSelect={() => {
                // TODO: Handle closure selection
              }}
              month={selectedMonth}
              onMonthChange={setSelectedMonth}
              locale={fr}
              className="rounded-lg border bg-white"
              classNames={{
                day: "relative",
              }}
              modifiers={{
                closure: closureDates,
              }}
              modifiersClassNames={{
                closure: "bg-red-100 text-red-600 hover:bg-red-200",
              }}
            />
          </div>

          {/* Age groups - flexible width */}
          <div className="flex-1">
            <AgeGroupsSection />
          </div>
        </div>

        {/* Edit button */}
        <div className="flex justify-end">
          <Button variant="outline" className="gap-2">
            <Pencil className="h-4 w-4" />
            Modifier la fiche
          </Button>
        </div>
      </div>
    </div>
  );
}
